// Extend global interfaces for polyfills
interface ObjectConstructor {
  assign<T, U>(target: T, source: U): T & U
  assign<T, U, V>(target: T, source1: U, source2: V): T & U & V
  assign<T, U, V, W>(
    target: T,
    source1: U,
    source2: V,
    source3: W
  ): T & U & V & W
  assign(target: any, ...sources: any[]): any
}

interface String {
  includes(searchString: string, position?: number): boolean
}

// IE-11 object.assign polyfill
if (typeof Object.assign !== 'function') {
  ;(function () {
    Object.assign = function (target: any) {
      'use strict'
      // We must check against these specific cases.
      if (target === undefined || target === null) {
        throw new TypeError('Cannot convert undefined or null to object')
      }

      const output = Object(target)
      for (let index = 1; index < arguments.length; index++) {
        const source = arguments[index]
        if (source !== undefined && source !== null) {
          for (const nextKey in source) {
            // eslint-disable-next-line no-prototype-builtins
            if (source.hasOwnProperty(nextKey)) {
              output[nextKey] = source[nextKey]
            }
          }
        }
      }
      return output
    }
  })()
}

if (!String.prototype.includes) {
  const string = String
  string.prototype.includes = function (search: string, start?: number) {
    'use strict'
    if (typeof start !== 'number') {
      start = 0
    }

    if (start + search.length > this.length) {
      return false
    } else {
      return this.indexOf(search, start) !== -1
    }
  }
}
